import React from "react";
// import reference from "../reference";
import { baseURL, baseURL1 } from "../../../Redux/baseURL";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getting_profile_successful, getting_employer_profile_successful } from "../../../Redux/ActionCreator";

function EmployerProfilePhoto() {
  const dispatch = useDispatch();
  const stat = useSelector(e => e.login);
  const userInfo = useSelector(e => e.userInfo);
  const [previewUrl, setPreviewUrl] = useState("");
  const navigate = useNavigate();
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        // e.target.result contains the base64-encoded image data URL
        setPreviewUrl(e.target.result);
        console.log("We did it baby"); // yes bro!!
      };

      // Read the file as a data URL (base64)
      reader.readAsDataURL(file);
    } else {
      // Handle the case where no file is selected.
      console.error("No file selected.");
    }
  };

  console.log("Base64URL", previewUrl);
  

  const sendBase64UrlToBackend = () => {
    if (previewUrl) {
      let token = localStorage.getItem("token");
      const body = {
        image_uri: previewUrl, // Send the base64 image data URL
      };

      const headers = {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      if (stat.profile_status.AcctType === "Official") {
        fetch(baseURL + "/api/employer/upload_photo", {
          method: "PATCH",
          body: JSON.stringify(body), // Send the JSON object containing the base64 URL
          headers,
        })
          .then((resp) => resp.json())
          .then((resp) => {
            console.log(resp);
            if (resp.success === true) {
              dispatch(getting_employer_profile_successful(resp.data))
              console.log("Success, we did it"); // yes bro!!
              navigate("/user/employer/profile");
            }
          });
      } else if (stat.profile_status.AcctType === "Client") {
        fetch(baseURL + "/api/client/upload_avatar", {
          method: "PATCH",
          body: JSON.stringify(body), // Send the JSON object containing the base64 URL
          headers,
        })
          .then((resp) => resp.json())
          .then((resp) => {
            console.log(resp);
            if (resp.success === true) {
              dispatch(getting_profile_successful(resp.data));
              console.log("Success, we did it"); // yes bro!!
              navigate(`/user/profile/:${userInfo.user.profile_id}`);
            }
          });
      }
    } else {
      console.error("No file selected.");
    }
  };

 

  return (
    <div className="px-[2.5%] w-full h-full overflow-y-hidden mx-auto">
    <div className="w-full mt-4 bg-transparent border-2 border-[#D1D3F7] rounded-full px-6 py-[0.375rem] font-semibold text-3xl text-black">
      Business Profile
    </div>
    <p className="w-full my-12 font-medium text-base text-black">
      Complete this form create an employer or business profile.
    </p>

    {/* Main content of page  */}
    <div className="bg-[#FEFEFE] w-full rounded-2xl border-2 border-[#D1D3F7] flex flex-col justify-center gap-16 tablet:px-16 px-2 py-8">
      <div className="w-full font-medium text-base text-black">
        <p>Upload a photo that represents your company/business.</p>
        <p>
          It can be your business logo. It will be visible to anyone who
          visits your profile.
        </p>
      </div>
      <div>
        <button className="bg-[#FED1C1] px-7 py-3 font-medium text-lg text-black rounded-full">
          Profile Photo
        </button>
      </div>
      <div>
        <div className=" max-w-[220px] max-h-[220px] w-full h-full ">
          {previewUrl === "" ? (
            <p>Click on the button below to select an Image to preview</p>
          ) : (
            <img
              src={previewUrl}
              alt=""
              className="max-w-[220px] max-h-[220px] w-full h-full rounded-lg"
            />
          )}
        </div>

        {/* image upload input field  */}
        <label className="custom-file-upload">
          <input type="file" accept="image/*" onChange={handleFileChange} className="invisible"/>
          <div className="bg-[#FED1C1] px-7 py-3 font-medium text-lg text-black rounded-full flex items-center gap-2 w-fit">
          <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V6C1.69779e-06 5.45 0.196002 4.979 0.588002 4.587C0.980002 4.195 1.45067 3.99933 2 4H5.15L7 2H13V4H7.875L6.05 6H2V18H18V9H20V18C20 18.55 19.804 19.021 19.412 19.413C19.02 19.805 18.5493 20.0007 18 20H2ZM18 6V4H16V2H18V0H20V2H22V4H20V6H18ZM10 16.5C11.25 16.5 12.3127 16.0623 13.188 15.187C14.0633 14.3117 14.5007 13.2493 14.5 12C14.5 10.75 14.0623 9.68733 13.187 8.812C12.3117 7.93667 11.2493 7.49933 10 7.5C8.75 7.5 7.68734 7.93767 6.812 8.813C5.93667 9.68833 5.49934 10.7507 5.5 12C5.5 13.25 5.93767 14.3127 6.813 15.188C7.68834 16.0633 8.75067 16.5007 10 16.5ZM10 14.5C9.3 14.5 8.70834 14.2583 8.225 13.775C7.74167 13.2917 7.5 12.7 7.5 12C7.5 11.3 7.74167 10.7083 8.225 10.225C8.70834 9.74167 9.3 9.5 10 9.5C10.7 9.5 11.2917 9.74167 11.775 10.225C12.2583 10.7083 12.5 11.3 12.5 12C12.5 12.7 12.2583 13.2917 11.775 13.775C11.2917 14.2583 10.7 14.5 10 14.5Z"
              fill="#F24E1E"
            />
          </svg>
          Upload photo
          </div>
        </label>
      </div>

      <div className="w-full flex justify-between">
        <button className="flex items-center text-[#FF6633] font-medium text-base gap-1">
          <svg
            width="9"
            height="10"
            viewBox="0 0 9 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.5 1C8.5 0.867392 8.44732 0.740215 8.35355 0.646447C8.25979 0.552679 8.13261 0.5 8 0.5C7.86739 0.5 7.74021 0.552679 7.64645 0.646447C7.55268 0.740215 7.5 0.867392 7.5 1V4.248L1.233 0.612C0.713 0.31 0 0.655 0 1.308V8.692C0 9.345 0.713 9.69 1.233 9.388L7.5 5.752V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74021 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35355 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V1ZM1 1.633L6.804 5L1 8.367V1.633Z"
              fill="#F24E1E"
            />
          </svg>

          <span>Skip</span>
        </button>

        <button
          onClick={sendBase64UrlToBackend}
          className="text-white text-base font-semibold rounded-lg bg-[#5843BD] py-3 px-5 whitespace-nowrap"
        >
          Save business profile
        </button>
      </div>
    </div>
  </div>
  );
}

export default EmployerProfilePhoto;
